import React from 'react';
import type { Toast } from '../hooks/useToast';

interface Props {
  toasts: Toast[];
  onDismiss: (id: string) => void;
}

export default function ToastContainer({ toasts, onDismiss }: Props) {
  if (toasts.length === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 200,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}
    >
      {toasts.map((toast) => {
        const isAlert = toast.type === 'alert';
        return (
          <div
            key={toast.id}
            role="alert"
            className="panel"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '10px 14px',
              minWidth: 280,
              borderLeft: `2px solid ${isAlert ? 'var(--amber)' : 'var(--signal)'}`,
            }}
          >
            <span
              className="mono"
              style={{
                fontSize: 12,
                color: 'var(--text)',
                letterSpacing: '0.04em',
              }}
            >
              {toast.coin && (
                <span className="serif" style={{ fontWeight: 700, marginRight: 8, fontSize: 13 }}>
                  {toast.coin}
                </span>
              )}
              {toast.message}
            </span>
            <button
              type="button"
              onClick={() => onDismiss(toast.id)}
              className="muted"
              style={{
                marginLeft: 'auto',
                fontFamily: 'var(--mono)',
                fontSize: 12,
                padding: '0 4px',
              }}
              aria-label="Dismiss"
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
}
